module.exports = __webpack_public_path__ + "media/images/Vector-d2c0b34882b02531ae0ab7c83339145b.svg";